<template>
  <div>
      <div class="table-search-items">
        <div class="table-search-items__section">
          <label class="table-search-items__search">
            <input v-model="searchServices" type="text" :placeholder="getLocalization('Find service')"/>
            <img src="/img/svg/common/search-black.svg" alt=""/>
          </label>
        </div>
      </div>
    <div class="--grid-line --grid-line-one" itemprop="dataset" itemscope itemtype="http://schema.org/Table">
      <div class="--table-scroll" itemprop="hasPart" itemscope itemtype="http://schema.org/Table">
        <table itemprop="tableSchema" itemscope itemtype="http://schema.org/Table">
          <thead>
          <tr>
            <td itemprop="columnHeader">{{getLocalization('Name')}}</td>
            <td width="36px" itemprop="columnHeader">{{getLocalization('ID')}}</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="service in searchServiceList" itemscope itemtype="http://schema.org/TableRow">
            <td itemprop="name">
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center gap-2">
                  <img :src="service['img_path']" width="16" height="16" class="object-fit-cover" :alt="service['title']"/>
                  <span itemprop="description">{{service['title']}}</span>
                </div>
                <div class="--line"></div>
              </div>
            </td>
            <td itemprop="identifier">
              <div>{{service['activate_org_code']}}</div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "apiService",

  props: [
    'services'
  ],
  data: function () {
    return {
      searchServices: ''
    }
  },
  computed: {
    searchServiceList() {
      if (!this.searchServices) {
        return [...this.services]
      }

      const searchService = (this.searchServices || '').trim().toLowerCase();

      return this.services.filter(service => {
        const hasAltSearch = !!service.alternative_params?.name_search;

        if (hasAltSearch) {
          return service.alternative_params.name_search.toLowerCase().includes(searchService);
        }

        return service.title?.toLowerCase().includes(searchService);
      });
    },
  }
}
</script>
<style scoped>
.--grid-line-one {
  min-height: 280px;
}
</style>
